import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    inputController: {
      '&:not($inputShrink)': {
        paddingRight: theme.spacing(8),
      },
    },
    inputShrink: {},
  }),
  {index: 1},
);

export default useStyles;
